module.exports = __webpack_public_path__ + "static/staff@large-a5eee207e9bfe2737cccb36f519b1df9.jpg";